


































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { ConsentConditionType, WaterMeter } from '@/api';
import {
	ConsentConditionModule,
	ConsentConditionWithParams,
	FixedDateVolumeParameters,
	isConsentConditionWithParams,
} from '@/modules';
import Toast from '@/components/display/toast.vue';
import SaveCancelButtons from '@/components/elements/buttons/save-cancel-buttons.vue';

@Component({
	components: { SaveCancelButtons },
})
export default class WaterConsentConditionEdit extends Vue {
	@Prop() isNew!: boolean;
	@Prop() conditionType: ConsentConditionType | null | undefined;
	@Prop() conditionId!: number;
	@Prop() waterMeters!: WaterMeter[];
	@Prop() consentId!: number;

	@Watch('consentCondition.parameters.startMonth')
	public resetStartDay() {
		this.resetDayOfMonth('startDate');
	}

	@Watch('consentCondition.parameters.endMonth')
	public resetEndDay() {
		this.resetDayOfMonth('endDate');
	}

	consentCondition: ConsentConditionWithParams | null = null;
	consentConditionModule: ConsentConditionModule;
	meterSelectOptions: { text: string; value: number }[] = [];
	renderKey: number = 1;
	waterMeterIds: number[] = [];

	constructor() {
		super();

		this.consentConditionModule = new ConsentConditionModule();
		if (this.waterMeters.length) {
			this.meterSelectOptions = this.waterMeters.map(wm => {
				return { text: wm.name, value: wm.id };
			});
		}
	}

	public mounted() {
		this.load();
	}

	async load() {
		this.consentCondition = null;
		if (this.conditionId) {
			this.consentCondition = await this.consentConditionModule.get(this.conditionId);
			if (this.consentCondition) {
				this.waterMeterIds = this.consentCondition.parameters.waterMeterIds || [];
			}
		} else {
			if (this.conditionType)
				this.consentCondition = {
					consentId: this.consentId,
					consentConditionTypeId: this.conditionType.id,
					consentconditiontype: this.conditionType,
					parameters: {
						volumeValue: undefined,
						volumeUnit: undefined,
						waterMeterIds: [],
					},
				};

			if (this.consentCondition != undefined && this.conditionType != undefined) {
				if (this.conditionType.name === 'rollingPeriodVolume') {
					this.consentCondition.parameters = {
						...this.consentCondition.parameters,
						...{ periodUnit: null, periodValue: null, start: null },
					};
				}
				if (this.conditionType.name === 'rollingPeriodVolume') {
					this.consentCondition.parameters = {
						...this.consentCondition.parameters,
						...{ periodUnit: null, periodValue: null, start: null },
					};
				} else if (this.conditionType.name === 'fixedDateVolume') {
					this.consentCondition.parameters = {
						...this.consentCondition.parameters,
						...{
							startDay: null,
							startMonth: null,
							endDay: null,
							endMonth: null,
							periodUnit: null,
							periodValue: null,
						},
					};
				}
			}
		}
	}

	async handleSubmit(e: any) {
		e.preventDefault();
		if (this.consentCondition) {
			if (!isConsentConditionWithParams(this.consentCondition)) {
				new Toast().makeToast(
					'Validation of the condition parameters failed',
					'Invalid parameters',
					'danger',
				);
			} else {
				try {
					await this.consentConditionModule.save(this.consentCondition, this.conditionId);
				} catch (ex) {
					console.error(ex);
					new Toast().makeToast(
						`Error during save - ${ex.message} `,
						'ERROR - Failed to save ',
						'danger',
					);
				}
				this.$emit('closeModal');
				this.$emit('reloadConsent');
			}
		}
	}

	getMonths(): { key: number; value: { displayText: string; numOfDays: number } }[] {
		return [
			{ key: 1, value: { displayText: 'Jan', numOfDays: 31 } },
			{ key: 2, value: { displayText: 'Feb', numOfDays: 28 } },
			{ key: 3, value: { displayText: 'Mar', numOfDays: 31 } },
			{ key: 4, value: { displayText: 'Apr', numOfDays: 30 } },
			{ key: 5, value: { displayText: 'May', numOfDays: 31 } },
			{ key: 6, value: { displayText: 'Jun', numOfDays: 30 } },
			{ key: 7, value: { displayText: 'Jul', numOfDays: 31 } },
			{ key: 8, value: { displayText: 'Aug', numOfDays: 31 } },
			{ key: 9, value: { displayText: 'Sep', numOfDays: 30 } },
			{ key: 10, value: { displayText: 'Oct', numOfDays: 31 } },
			{ key: 11, value: { displayText: 'Nov', numOfDays: 30 } },
			{ key: 12, value: { displayText: 'Dec', numOfDays: 31 } },
		];
	}

	getDaysOfMonth(monthNum: number): number[] {
		const months = this.getMonths();
		const thisMonth = months.find(element => element.key === monthNum);
		if (thisMonth == undefined) {
			return [];
		} else {
			let result = [];
			for (let x = 1; x <= thisMonth.value.numOfDays; x++) {
				result.push(x);
			}
			return result;
		}
	}

	resetDayOfMonth(val: 'startDate' | 'endDate') {
		if (this.consentCondition) {
			if (this.consentCondition == null) {
				return;
			}
			const months = this.getMonths();

			let newMonth;
			if (val === 'startDate') {
				newMonth = months.find(
					element => element.key === this.consentCondition.parameters.startMonth || 0,
				);
			} else {
				newMonth = months.find(
					element => element.key === this.consentCondition.parameters.endMonth || 0,
				);
			}

			if (
				val === 'startDate' &&
				this.consentCondition.parameters.startDay > newMonth.value.numOfDays
			) {
				this.consentCondition.parameters.startDay = null;
			} else if (
				val === 'endDate' &&
				this.consentCondition.parameters.endDay > newMonth.value.numOfDays
			) {
				this.consentCondition.parameters.endDay = null;
			}
		}
	}
}
